<template>
	<div>
		<ConveyancingFieldsetQuoteType :form="form"/>
		<ConveyancingFieldsetSale :form="form"/>
		<ConveyancingFieldsetPurchase :form="form"/>
		<ConveyancingFieldsetRemortgage :form="form"/>
	</div>
</template>
<script>
import ConveyancingFieldsetPurchase from "./ConveyancingFieldsetPurchase.vue";
import ConveyancingFieldsetQuoteType from "./ConveyancingFieldsetQuoteType.vue";
import ConveyancingFieldsetRemortgage from "./ConveyancingFieldsetRemortgage.vue";
import ConveyancingFieldsetSale from "./ConveyancingFieldsetSale.vue";

export default {
	components: {
		ConveyancingFieldsetQuoteType,
		ConveyancingFieldsetPurchase,
		ConveyancingFieldsetRemortgage,
		ConveyancingFieldsetSale,
	},
	props: {
		form: {
			required: true,
			type: Object,
		},
	},
};
</script>
